goog.provide('el8.appchart.dialog.setDateTime');

goog.require('el8.service.tz');
goog.require('el8.template.appchart.dialog.setDateTime');
goog.require('el8.uiwidget.alert');
goog.require('el8.uiwidget.Form');
goog.require('el8.uiwidget.FormDialog');
goog.require('el8.util.consts');


el8.appchart.dialog.setDateTime = (function() {
    var saveCb = null;
    var cancelCb = null;
    var validateFn = null;
    var dateOnly = null;
    var defaultDateTime = null;
    var DEFAULT_TITLE = 'Set Date and Time';

    var that = new el8.uiwidget.FormDialog({
        title: DEFAULT_TITLE,
        autoHeight: true,
        width: 300,
        modal: true,
        contentFn: function() { return el8.template.appchart.dialog.setDateTime.content({}); }
    });

    var form = new el8.uiwidget.Form({
        fields: [
            {
                name: 'date',
                selector: ':input[name="date"]',
                infoText: 'date...',
                datePickerOpts: {}
            },
            {
                name: 'time',
                selector: ':input[name="time"]',
                timePickerOpts: {
                    increment: 1
                }
             }
        ]
    });
    form.addSaveButton(function(_form) {
        var dateTime = el8.service.tz.processDateAndTimeInputs(
            _form.getVal('date'), _form.getVal('time'));

        if (!dateTime) {
            el8.uiwidget.alert('Please enter a valid date and time.');
            return;
        }
        if (validateFn && !validateFn(dateTime)) { return; }

        if (saveCb) { saveCb(dateTime); }
        that.hide();
    }, true);
    form.addDiscardChangesButton(function() {
        if (cancelCb) { cancelCb(); }
        that.hide();
    });
    that.setForm(form);

    var super_show = that.show;
    that.show = function(opts) {
        super_show.call(that);

        cancelCb = opts.cancelCallbackFn || null;
        saveCb = opts.saveCallbackFn || null;
        validateFn = opts.validateFn || defaultValidateFn;
        defaultDateTime = opts.defaultDateTime || el8.service.tz.now();
        dateOnly = opts.dateOnly || false;

        form.setVal('date', defaultDateTime.asString());
        form.setVal('time', defaultDateTime.asTimeString());
        if (opts.title) { that.setTitle(opts.title); }
        if (opts.msg) { $('.optional-explanation', that.getContentElt()).text(opts.msg); }

        if (dateOnly) {
            var $elt = that.getContainer();
            $(':input[name="time"]', $elt).parent().parent().hide();
            $elt.parent().outerWidth(200);
        }
    };

    var super_hide = that.hide;
    that.hide = function() {
        cancelCb = null;
        saveCb = null;
        validateFn = null;
        defaultDateTime = null;

        that.setTitle(DEFAULT_TITLE);
        super_hide.call(that);
        $('.optional-explanation', that.getContentElt()).empty();
    };

    function defaultValidateFn(dateTime) {
        if (dateTime <= el8.util.consts.MIN_DATE) {
            el8.uiwidget.alert('Please enter a valid date.');
            return false;
        }
        return true;
    }

    return that;

})();
